import apiClient from '../helpers/apiClient'

// WP-X8 — partner-expert self-registration, against #46's deployed partner endpoint
// (/api/v1/expertise/my-partner-expert-profile/, MyPartnerExpertProfileView). BLOCKED on #46 deploy
// for verification; built against its contract.
//
//   GET  /expertise/my-partner-expert-profile/
//        200 -> ExpertProfile (read) | 404 {detail} no profile yet | 403 not a partner account
//   PUT  /expertise/my-partner-expert-profile/   (upsert; partial when it already exists)
//        body: { headline, bio, listedRate, currency, rateType, availabilityNote,
//                expertiseAreas:[catalogId], isListed, active }
//        201 created | 200 updated -> ExpertProfile (read)

const URL = '/expertise/my-partner-expert-profile/'

export interface PartnerExpertWritePayload {
  headline?: string
  bio?: string
  listedRate?: number | null
  currency?: string
  rateType?: string
  availabilityNote?: string
  expertiseAreas?: number[]
  isListed?: boolean
  active?: boolean
}

export const getMyPartnerExpertProfile = async () => {
  const response = await apiClient.get(URL)
  return response.data
}

export const saveMyPartnerExpertProfile = async (payload: PartnerExpertWritePayload) => {
  const response = await apiClient.put(URL, payload)
  return response.data
}

export const getExpertiseList = async (partnerId: number, state?: "open" | "closed" | "requests") => {
  let params: any = {
    partner: partnerId,
  };
  if(state)
    params.state = state;
  const response = await apiClient.get(`/expertise/admin/expertise-services/`, {params})
  return response.data
}

export const getExpertiseAdminList = async (status: "new"|"rejected"|"active", limit: number, offset: number, search?: string) => {
  let params: any = {};
  // PR-I-87 — el tab UI usa 'new' pero el backend (STATUS_CHOICES en ExpertiseService) espera
  // 'pending' desde la migracion 0010. Mapeamos aqui para no propagar el rename a toda la UI y
  // para que el filtro efectivamente aplique: sin el mapeo, el backend descarta el status
  // desconocido y devuelve la lista sin filtrar (era el bug visible: tab 'New' mostraba activos).
  if(status)
    params.status = status === 'new' ? 'pending' : status;
  if(limit)
    params.limit = limit;
  if(offset)
    params.offset = offset;
  if(search)
    params.search = search;
  const response = await apiClient.get(`/expertise/admin/expertise-services/`, {params})
  return response.data
}

export const getExpertiseAdminDetail = async (id: number) => {
  const response = await apiClient.get(`/expertise/admin/expertise-services/${id}/`)
  return response.data
}

export const getExpertiseCounters = async (partnerId: number) => {
  let params: any = {
    partner: partnerId,
  };
  const response = await apiClient.get(`/expertise/admin/expertise-services/counters/`, {params})
  return response.data
}

// PR-I-87 — admin moderation actions sobre expertise-services.
// Backend en expertise/views.py AdminExpertiseServiceViewSet:
//   PATCH /expertise/admin/expertise-services/<id>/approve/   (sin body)
//   PATCH /expertise/admin/expertise-services/<id>/reject/    body: { reason_id, note? }
// El listado ya devuelve status/statusDisplay, asi que despues del PATCH refrescamos tabla + drawer.
export const approveExpertiseAdmin = async (id: number) => {
  const response = await apiClient.patch(`/expertise/admin/expertise-services/${id}/approve/`)
  return response.data
}

export const rejectExpertiseAdmin = async (id: number, reasonId: number, note?: string) => {
  const body: { reason_id: number; note?: string } = { reason_id: reasonId }
  if (note && note.trim().length > 0) {
    body.note = note.trim()
  }
  const response = await apiClient.patch(`/expertise/admin/expertise-services/${id}/reject/`, body)
  return response.data
}

// GET /expertise/decline-reasons/ — catalogo publico del dropdown (list-only, no admin).
export const getExpertiseDeclineReasons = async () => {
  const response = await apiClient.get(`/expertise/decline-reasons/`)
  return response.data
}

export const getCommunityPartnerCounter = async (partnerId: number) => {
  const response = await apiClient.get(`/community/admin/partners/${partnerId}/community/counters/`)
  return response.data
}

export const getMastermindPartnerList = async (partnerId: number, limit: number, offset: number) => {
  let params = { limit, offset }
  const response = await apiClient.get(`/community/admin/partners/${partnerId}/community/mastermind-circles/`, { params })
  return response.data
}

export const getForumPartnerList = async (partnerId: number, limit: number, offset: number) => {
  let params = { limit, offset }
  const response = await apiClient.get(`/community/admin/partners/${partnerId}/community/open-forums/`, { params })
  return response.data
}



